const globalizedColors = {
  GLOBALIZED_50: '#FAFAFA',
  GLOBALIZED_100: '#F5F5F5',
  GLOBALIZED_200: '#EFEFEF',
  GLOBALIZED_500: '#A0A0A0',
}

export default globalizedColors
